import type { FC } from 'react';

import type { IllustrationProps } from './types';

export const ClockIllustration: FC<IllustrationProps> = ({
  height = 128,
  width = 129,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 129 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.3737 107.733C38.5016 107.23 38.1434 106.154 38.5397 105.228L43.2141 94.3086L49.0798 97.6952L41.9605 107.203C41.3568 108.009 40.2459 108.237 39.3737 107.733Z"
      fill="#0D3880"
    />
    <path
      d="M93.4356 107.733C94.3078 107.23 94.666 106.154 94.2696 105.228L89.5953 94.3086L83.7295 97.6952L90.8489 107.203C91.4525 108.009 92.5634 108.237 93.4356 107.733Z"
      fill="#0D3880"
    />
    <path
      d="M39.14 71.8251C39.0166 71.8251 38.8951 71.8334 38.7744 71.8436C38.3527 65.8535 33.3631 61.124 27.2657 61.124C22.0835 61.124 17.6993 64.5397 16.2409 69.2422C15.642 69.0395 15.0027 68.9244 14.3354 68.9244C11.0531 68.9244 8.39258 71.5852 8.39258 74.8675C8.39258 75.3155 8.44612 75.7504 8.54005 76.1702H43.4847C43.4847 73.7705 41.5394 71.8251 39.14 71.8251Z"
      fill="#88E2E9"
    />
    <path
      d="M39.5747 30.6284L32.3828 37.8203L40.3187 45.7562L47.5107 38.5643L39.5747 30.6284Z"
      fill="#F8B1DC"
    />
    <path
      d="M26.5745 47.6978C20.2118 41.4258 20.1382 31.1833 26.4102 24.8206C32.6822 18.4578 42.9247 18.3843 49.2874 24.6563L26.5745 47.6978Z"
      fill="#EE399E"
    />
    <path
      d="M85.2993 38.5639L92.4912 45.7559L100.427 37.8199L93.2352 30.628L85.2993 38.5639Z"
      fill="#F8B1DC"
    />
    <path
      d="M106.235 47.6978C112.598 41.4258 112.672 31.1833 106.4 24.8206C100.128 18.4578 89.8852 18.3843 83.5225 24.6563L106.235 47.6978Z"
      fill="#EE399E"
    />
    <path
      d="M66.4048 103.258C87.2635 103.258 104.173 86.3484 104.173 65.4897C104.173 44.631 87.2635 27.7217 66.4048 27.7217C45.5461 27.7217 28.6367 44.631 28.6367 65.4897C28.6367 86.3484 45.5461 103.258 66.4048 103.258Z"
      fill="#EE399E"
    />
    <path
      d="M66.4053 91.7412C80.9039 91.7412 92.6573 79.9878 92.6573 65.4893C92.6573 50.9907 80.9039 39.2373 66.4053 39.2373C51.9067 39.2373 40.1533 50.9907 40.1533 65.4893C40.1533 79.9878 51.9067 91.7412 66.4053 91.7412Z"
      fill="white"
    />
    <path
      d="M67.4053 43.1816H65.4053V46.9365H67.4053V43.1816Z"
      fill="#B6C7E0"
    />
    <path d="M67.4053 84.043H65.4053V87.7974H67.4053V84.043Z" fill="#B6C7E0" />
    <path d="M88.7119 64.4902H84.958V66.4902H88.7119V64.4902Z" fill="#B6C7E0" />
    <path
      d="M47.8525 64.4902H44.0977V66.4902H47.8525V64.4902Z"
      fill="#B6C7E0"
    />
    <path
      d="M66.4052 68.8944C68.2858 68.8944 69.8104 67.3698 69.8104 65.4892C69.8104 63.6085 68.2858 62.084 66.4052 62.084C64.5246 62.084 63 63.6085 63 65.4892C63 67.3698 64.5246 68.8944 66.4052 68.8944Z"
      fill="#0D3880"
    />
    <path
      d="M66.1943 68.3813L51.5752 53.7617C50.9424 53.1284 50.9424 52.102 51.5752 51.4687C52.208 50.8359 53.2354 50.8359 53.8682 51.4687L66.1943 63.7954L74.2139 55.7759C74.8467 55.1431 75.874 55.1431 76.5068 55.7759C77.1396 56.4092 77.1396 57.4355 76.5068 58.0688L66.1943 68.3813Z"
      fill="#0D3880"
    />
    <path
      d="M116.034 83.3896C115.424 83.3896 114.844 83.5127 114.315 83.7335C113.176 78.3691 108.415 74.3438 102.711 74.3438C96.1593 74.3438 90.8477 79.6551 90.8477 86.2073C90.8477 86.7671 90.8894 87.3169 90.9642 87.856H120.5C120.5 85.3893 118.5 83.3896 116.034 83.3896Z"
      fill="#88E2E9"
    />
  </svg>
);
